import { useState } from 'react'
import { useToggle } from 'react-use'

import { Offerings } from '@infura/packages.api'
import { ServiceTier } from '@infura/packages.uks'

import { UpgradePlanCheckoutModal } from 'components/upgradePlan/UpgradePlanCheckoutModal'
import { UpgradePlanModal } from 'components/upgradePlan/UpgradePlanModal'

import { useUKSServicePlan } from 'hooks/useUKSServicePlan'

interface Props {
  isUpgradePlanModalVisible: boolean
  toggleUpgradePlanModalVisible: () => void
  upgradePlanReason?: string
  useUpgradePlanModalVariation?: boolean
  offerings: Offerings
}

export const UpgradePlanModalsContainer = ({
  isUpgradePlanModalVisible,
  offerings,
  toggleUpgradePlanModalVisible,
  upgradePlanReason,
  useUpgradePlanModalVariation
}: Props) => {
  const [isCheckoutModalVisible, toggleCheckoutModalVisible] = useToggle(false)
  const [selectedPlan, setselectedPlan] = useState<null | ServiceTier>(null)
  const { servicePlan } = useUKSServicePlan()

  return (
    <>
      <UpgradePlanModal
        isUpgradePlanModalVisible={isUpgradePlanModalVisible}
        // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
        selectedPlan={selectedPlan}
        setselectedPlan={setselectedPlan}
        tiers={offerings.tiers}
        toggleCheckoutModalVisible={toggleCheckoutModalVisible}
        toggleUpgradePlanModalVisible={toggleUpgradePlanModalVisible}
        upgradePlanReason={upgradePlanReason}
        useUpgradePlanModalVariation={useUpgradePlanModalVariation}
      />
      <UpgradePlanCheckoutModal
        isCheckoutModalVisible={isCheckoutModalVisible}
        offerings={offerings}
        selectedPlan={selectedPlan || ServiceTier.CORE}
        servicePlan={servicePlan}
        toggleCheckoutModalVisible={toggleCheckoutModalVisible}
      />
    </>
  )
}
